export default {"src":"/_next/static/media/GS.17ea39ae.svg","height":18,"width":18};